import Vue from 'vue';
import { Component, Prop, Provide, Watch } from 'vue-property-decorator';
import * as Logger from 'js-logger';
import StageHeader from '../../components/stageHeader';
import MessageModal from '../../components/messageModel';
import clientService from '../../services/axios/axiosService';
import backendService from '../../services/axios/tmsServiceBackend';
import tmsService from '../../services/axios/tmsService';
import qs from 'qs';
import switchBillingToService from '../../shared/switchBillingToService';
import tmsTransformRequestService from '../../services/axios/tmsTransformRequestService';
import template from './messageCenter.vue';
import MainButtonSet from '../../components/mainButtonSet';

@Component({
    mixins: [template],
    components: {
        StageHeader,
        MainButtonSet,
        MessageModal,
    },
})
export default class MessageCenter extends Vue {
    isLoading: boolean = false;
    orders: Array<Object> = [];
    currentOrderInfo: any = '';
    isHideDetails: boolean = true;
    activeChild: any = 'Shipment #10292';
    activeOrderIdWithPrefix: any = '';
    activeOrderId: any = '';
    channelUrl: any = '';
    stepOneClass: any = '';
    stepTwoClass: any = '';
    stepThreeClass: any = '';
    stepOneBgClass: any = '';
    stepTwoBgClass: any = '';
    stepThreeBgClass: any = '';
    stepLineClass: any = '';
    currentStatus: any = '';
    iframeHeight: any = '';
    selectNavStatus: any = 1;
    customerOrderChannels: any = '';
    connectionCount: number = 0;
    generalNotificationModal: string = 'generalNotificationModal';
    generalNotificationTitle: string = 'Error';
    generalNotificationMessage: string = 'This channel is not ready yet.';
    trackingText: string = '';

    mounted() {
        this.getCustomerOrders();
        this.getBillToId(this.getCustomerOrderChannels);
        this.iframeHeight = (this.$refs.pageContainer as any).offsetHeight + 'px';
    }

    async getBillToId(callback: any) {
        try {
            this.isLoading = true;
            this.connectionCount += 1;

            switchBillingToService
                .post()
                .then((res: any) => {
                    callback(res);
                })
                .catch(error => {
                    console.log(error);
                });
        } catch (error) {
        } finally {
            this.connectionCount -= 1;
            if (this.connectionCount == 0) {
                this.isLoading = false;
            }
        }
    }

    async getCustomerOrderChannels(res: any) {
        try {
            if (res.data.billing) {
                let formData = {
                    customer_id: res.data.billing.location_id,
                };
                const response = await backendService.post(
                    '/messageCenter/getCustomerOrderChannels',
                    qs.stringify(formData)
                );
                const data = response.data.data;
                if (data) {
                    this.customerOrderChannels = data;
                }
            }
        } catch (error) {
        } finally {
            // this.connectionCount -= 1;
            // if(this.connectionCount == 0) {
            //   this.isLoading = false;
            // }
        }
    }

    clickRadioNav(index: any) {
        if (this.selectNavStatus === index) this.selectNavStatus = -1;
    }

    retractDetails() {
        this.isHideDetails = !this.isHideDetails;
    }

    // async showOrderInfo(order_id: any) {
    //   try {
    //     this.isLoading = true;
    //     let formData = {
    //       "orderId": order_id
    //     };
    //     let response = await clientService.post("write_new/get_order_tracking_info.php", qs.stringify(formData));
    //     if (response.data) {
    //       this.currentOrderInfo = response.data;
    //     }
    //   } catch (error) {

    //   }
    //   finally {
    //     this.isLoading = false;
    //   }
    // }

    unisAsideNav: any = [
        {
            groupName: 'General Notifications',
            leftIcon: require('@/assets/images/message.svg'),
        },
        {
            groupName: 'Shipments',
            isOpen: true,
            leftIcon: require('@/assets/images/turningdown.svg'),
            rightIcon: require('@/assets/images/add.svg'),
            childs: [],
        },
        // , {
        //     groupName: 'Internal Channels',
        //     leftIcon: require('@/assets/images/turningdown.svg'),
        //     rightIcon: require('@/assets/images/add.svg'),
        //     childs: [
        //         {title: "Shipment #10293"},
        //         {title: "Shipment #10293"},
        //         {title: "Shipment #10293"},
        //         {title: "Shipment #10293"},
        //     ],

        // }, {
        //     groupName: 'Direct Messages',
        //     leftIcon: require('@/assets/images/turningdown.svg'),
        //     rightIcon: require('@/assets/images/add.svg'),
        //     childs: [
        //         {title: "Shipment #10293"},
        //         {title: "Shipment #10293"},
        //         {title: "Shipment #10293"},
        //         {title: "Shipment #10293"},
        //     ],

        // }
    ];

    async getCustomerOrders() {
        try {
            this.isLoading = true;
            this.connectionCount += 1;
            let formData = {
                input_status: JSON.stringify([0, 1, 2, 3, 4]),
            };
            let response = await clientService.post(
                'write_new/get_tms_orders_customer.php',
                qs.stringify(formData)
            );
            if (response.data && response.data.rows) {
                this.orders = response.data.rows;
                let rows = response.data.rows;
                let that = this;
                rows.forEach(function(row: any) {
                    let title = that.generateTrackingText(row.pro, row.pu);
                    that.unisAsideNav[1].childs.push({
                        title: title,
                        order_id: row.order,
                        billto_id: row.fk_billto_id,
                    });
                });
            }
        } catch (error) {
        } finally {
            this.connectionCount -= 1;
            if (this.connectionCount == 0) {
                this.isLoading = false;
            }
        }
    }

    isRetractAside: boolean = false;

    retractAside() {
        this.isRetractAside = !this.isRetractAside;
    }

    clickOrder(order_id: any, billto_id: any) {
        this.isHideDetails = false;
        this.activeOrderId = order_id;
        this.activeOrderIdWithPrefix = 'Shipment #' + order_id;
        this.setOrderChannelIframeSrc(order_id, billto_id);
        this.updateOrderInfo(order_id);
    }

    async setOrderChannelIframeSrc(order_id: any, billto_id: any) {
        try {
            this.isLoading = true;
            this.connectionCount += 1;
            let formData = {
                order_id: order_id,
                customer_id: billto_id,
                channel_exists: this.customerOrderChannels.indexOf(order_id) != -1 ? 1 : 0,
            };
            const response = await backendService.post(
                '/messageCenter/getChannelUrlInfo',
                qs.stringify(formData)
            );
            const data = response.data.data;
            if (data) {
                this.channelUrl =
                    data['base_url'] +
                    '?ClientId=' +
                    data['client_id'] +
                    '&CustomerID=' +
                    billto_id +
                    '&OrderID=' +
                    order_id;
                this.getBillToId(this.getCustomerOrderChannels);
            }
        } catch (error) {
        } finally {
            this.connectionCount -= 1;
            if (this.connectionCount == 0) {
                this.isLoading = false;
            }
        }
    }

    async updateOrderInfo(order_id: any) {
        try {
            this.isLoading = true;
            this.connectionCount += 1;
            let formData = {
                orderId: order_id,
            };
            const response = await clientService.post(
                'write_new/get_order_tracking_info.php',
                qs.stringify(formData)
            );
            const data = response.data.data;
            if (data) {
                this.currentOrderInfo = data;
                this.showSteps(data['status']);
                this.generateTrackingText(data.tms_order_pro, data.pickup_id);
            }
        } catch (error) {
        } finally {
            this.connectionCount -= 1;
            if (this.connectionCount == 0) {
                this.isLoading = false;
            }
        }
    }

    generateTrackingText(pro: number, pickup_id: number) {
        if (pro) {
            this.trackingText = 'PRO' + pro;
        } else if (pickup_id) {
            this.trackingText = 'PU' + pickup_id;
        }
        return this.trackingText;
    }

    showSteps(trackingStatus: any) {
        if (trackingStatus == 'Delivered') {
            this.currentStatus = 'Delivered';
            this.stepOneClass = 'present-finish';
            this.stepTwoClass = 'present-finish';
            this.stepThreeClass = 'present-step';
            this.stepLineClass = 'step-line';
            this.stepOneBgClass = 'step-information-finish';
            this.stepTwoBgClass = 'step-information-finish';
            this.stepThreeBgClass = 'step-information-finish';
        } else if (trackingStatus == 'In Transit') {
            this.currentStatus = 'In transit';
            this.stepOneClass = 'present-finish';
            this.stepTwoClass = 'present-step';
            this.stepThreeClass = '';
            this.stepLineClass = 'step-line';
            this.stepOneBgClass = 'step-information-finish';
            this.stepTwoBgClass = 'step-information-finish';
            this.stepThreeBgClass = '';
        } else if (trackingStatus == 'Pickup Up') {
            this.currentStatus = 'Picked up';
            this.stepOneClass = 'present-step';
            this.stepTwoClass = '';
            this.stepThreeClass = '';
            this.stepLineClass = '';
            this.stepOneBgClass = 'step-information-finish';
            this.stepTwoBgClass = '';
            this.stepThreeBgClass = '';
        } else {
            this.currentStatus = 'New';
            this.stepOneClass = '';
            this.stepTwoClass = '';
            this.stepThreeClass = '';
            this.stepLineClass = '';
            this.stepOneBgClass = '';
            this.stepTwoBgClass = '';
            this.stepThreeBgClass = '';
        }
    }

    clickGroupName(index: any) {
        if (index == 0) {
            this.activeOrderIdWithPrefix = this.unisAsideNav[0]['groupName'];
            this.isHideDetails = true;
            this.getBillToId(this.getCustomerChannelUrlInfo);
        }
    }

    async getCustomerChannelUrlInfo(res: any) {
        try {
            this.isLoading = true;
            this.connectionCount += 1;
            if (res.data == '-1') {
                this.$modal.show(this.generalNotificationModal);
            }
            if (res.data.billing) {
                let bill_to_id = res.data.billing.location_id;
                if (bill_to_id) {
                    let formData = {
                        customer_id: bill_to_id,
                    };
                    const response = await backendService.post(
                        '/messageCenter/getChannelUrlInfo',
                        qs.stringify(formData)
                    );
                    const data = response.data.data;
                    if (data) {
                        this.channelUrl =
                            data['base_url'] +
                            '?ClientId=' +
                            data['client_id'] +
                            '&CustomerID=' +
                            bill_to_id +
                            '&IsHideMessage=1';
                    } else {
                        this.$modal.show(this.generalNotificationModal);
                    }
                } else {
                    this.$modal.show(this.generalNotificationModal);
                }
            }
        } catch (error) {
        } finally {
            this.connectionCount -= 1;
            if (this.connectionCount == 0) {
                this.isLoading = false;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/messagecenter/index.ts